var map = {
	"./1.png": 83226,
	"./2.png": 99436,
	"./3.png": 25825,
	"./4.png": 42179,
	"./5.png": 53812,
	"./6.png": 45582,
	"./arrow.svg": 20768,
	"./benefits.svg": 41170,
	"./bill.svg": 12485,
	"./contact.svg": 80646,
	"./contact1.svg": 863,
	"./contact2.svg": 86134,
	"./do3.png": 40035,
	"./dx-01.svg": 1078,
	"./dxbot.png": 80095,
	"./dxbot1.jpg": 83511,
	"./eidas.png": 12344,
	"./email.svg": 95396,
	"./functions.svg": 93894,
	"./header-dxbot.svg": 93327,
	"./header-i.svg": 16142,
	"./header.svg": 51579,
	"./ic_arrows.svg": 20144,
	"./ic_bezier_curve.svg": 51698,
	"./ic_bezier_curve_red.svg": 45799,
	"./ic_chart_bar.svg": 57804,
	"./ic_chart_line.svg": 87802,
	"./ic_cloud.svg": 61608,
	"./ic_code.svg": 13909,
	"./ic_code_red.svg": 39765,
	"./ic_decoration.svg": 2015,
	"./ic_decoration_white.svg": 95309,
	"./ic_euro.svg": 39512,
	"./ic_euro_red.svg": 94274,
	"./ic_export.svg": 11681,
	"./ic_export_red.svg": 29754,
	"./ic_git.svg": 73016,
	"./ic_git_red.svg": 28725,
	"./ic_lock.svg": 98905,
	"./ic_pencil.svg": 77654,
	"./ic_pencil_red.svg": 82351,
	"./ic_pixels.svg": 12421,
	"./ic_pixels_red.svg": 5800,
	"./ic_screwdriver.svg": 38579,
	"./ic_screwdriver_red.svg": 26449,
	"./ic_server.svg": 42381,
	"./ic_server_red.svg": 16235,
	"./ic_settings.svg": 64037,
	"./ic_settings_white.svg": 35314,
	"./ic_shield_protected.svg": 69716,
	"./ic_size.svg": 60358,
	"./ic_size_red.svg": 49300,
	"./ic_target.svg": 85477,
	"./ic_thunder_move.svg": 27913,
	"./ic_triangle.svg": 20976,
	"./ic_triangle_red.svg": 98136,
	"./identity-lock.jpg": 12038,
	"./identity-mock-m3.png": 72960,
	"./identity-mock-m4.png": 97645,
	"./identity-mock-m5.png": 42836,
	"./identity-mock-m6.png": 17143,
	"./identity-mock-m7.png": 84133,
	"./identity-mock2.png": 67755,
	"./identity1a.jpg": 96752,
	"./identity1b.jpg": 81667,
	"./identity1c.jpg": 68287,
	"./identity2.jpg": 93410,
	"./iphonex.svg": 41099,
	"./logo-e-1.png": 81842,
	"./logo-e-2.png": 42974,
	"./logo-e-3.png": 40538,
	"./macbook.svg": 90325,
	"./mobile.svg": 83909,
	"./multiplataform.svg": 57325,
	"./notify.svg": 9802,
	"./per-email.svg": 50623,
	"./per-logo.svg": 86445,
	"./per-template.svg": 92542,
	"./productivity.png": 11273,
	"./save.svg": 76773,
	"./sec-iden.svg": 46133,
	"./security-iden.svg": 65872,
	"./security.svg": 64988,
	"./send.svg": 52819,
	"./server.svg": 62458,
	"./sign.jpg": 64291,
	"./sign.png": 72306,
	"./signature-m.png": 46996,
	"./signature-m2.png": 64336,
	"./signature-m5.png": 8667,
	"./signature-m6.png": 87522,
	"./signature.png": 26061,
	"./signature1.jpg": 19219,
	"./team.svg": 61567,
	"./tech.svg": 22842,
	"./ui-kit.png": 36851,
	"./unlock.svg": 88597,
	"./w-paper.svg": 22828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70779;